import { makeFormStateWithModel } from 'formtastisch'
import { type IntlShape } from 'react-intl'

import { type ContactRequestV1 } from '@redteclab/api/clients/bully'

import {
  validateEmail,
  validatePhoneNumber,
  validateRequired,
} from '../base-form-handling'

export const contactFormMakeContactFormState = ({
  initialData,
  intl,
}: {
  initialData: ContactRequestV1 & { phoneNumber?: string }
  intl: IntlShape
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types -- the rule was disabled before a comment became required
}) => {
  return makeFormStateWithModel({
    initialData,
    validations: {
      email: (value) => {
        return validateEmail(
          value,
          intl.formatMessage({ id: 'error.email.invalid' }),
        )
      },
      fcSolution: (value) => {
        if (window.automatedTestsSkipCaptcha) {
          return { valid: true }
        }

        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      firstName: (value) => {
        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      lastName: (value) => {
        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      message: (value) => {
        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      orderId: (value) => {
        // This is a form case for when the user is not logged in but still wants access to the orderId field
        // Therefore, does not require a validation for it
        if (!initialData.firstName) {
          return { valid: true }
        }

        if (value === undefined) {
          return { valid: true }
        }

        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      phoneNumber: (value) => {
        if (value) {
          return validatePhoneNumber(
            value,
            intl.formatMessage({ id: 'address.error.phone.invalid' }),
          )
        }

        return { valid: true }
      },
      productCode: (value) => {
        if (value === undefined) {
          return { valid: true }
        }

        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      subject: (value) => {
        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
    },
  })
}

export type ContactFormState = ReturnType<
  typeof contactFormMakeContactFormState
>
